import React, {useState} from 'react';
import './Profile.css';
import Header from './Header';
import Cover from './Cover';
import Post from './Post';
import PostHeader from './PostHeader';

function Profile({username, userId, birthday, email, password, profilePic, coverPic}) {
    const [about, setAbout] = useState(true)
    const button = () => {
        setAbout(!about)
    }
    return (
        <div className="profile">
            <Cover 
            coverPic = {coverPic}
            profilePic = {profilePic}
            username = {username}
            email = {email}
            />
            <PostHeader 
            profilePic={profilePic}
            username = {username}
            userId = {userId}
            button = {button}
            about = {about}
            />
            <Post 
            profilePic={profilePic}
            username = {username}
            userId = {userId}
            about = {about}
            />
        </div>
    )
}

export default Profile
